import { api } from "@shared/lib/api";
import {
  BackednResponse,
  IFilTerValue,
  IGetCreators,
  IGetFaectValue,
} from "@shared/lib/types";
import {
  IYoutubeScrapeRequest,
  IYoutubeScrapeResponse,
  SocialMedia,
} from "@shared/lib/types/influencer";

export class DiscoveryService {
  public static async getCreators(
    platform: string,
    searchQuery: string,
    limit: number,
    pageNo: number,
    filters: { [key: string]: IFilTerValue },
    bucketId?: string
  ) {
    const url = `social-media/search/searchV1`;
    const influencers = (await api
      .post(url, {
        json: {
          platform,
          searchQuery,
          ...filters,
          limit,
          pageNo,
          bucket: bucketId,
        },
      })
      .json()) as BackednResponse<IGetCreators>;
    return influencers;
  }

  public static async getFacets() {
    return (await api
      .get("social-media/search/searchV1/facets")
      .json()) as BackednResponse<IGetFaectValue>;
  }
  public static async addSocialMedia(socialMedia: Partial<SocialMedia>) {
    return await api
      .post(`social-media`, {
        json: {
          ...socialMedia,
        },
      })
      .json();
  }

  public static async getYoutubeScrapeVideos(
    socialMedia: IYoutubeScrapeRequest
  ) {
    return (await api
      .post(`social-media/search/youtube/videos`, {
        json: socialMedia,
      })
      .json()) as BackednResponse<IYoutubeScrapeResponse>;
  }
}
